import axiosInstance from "../app/axios";

export const getCurrencies = async (base?: string) => {
  const params = base ? { base } : {};
  const result = await axiosInstance.get("currency", { params });

  return result.data;
};

export const createCurrency = async (data: any) => {
  const result = await axiosInstance.post("currency", data);
  return result.data;
};

export const updateCurrency = async (id: number, data: any) => {
  const result = await axiosInstance.patch(`currency/${id}`, data);
  return result.data;
};

export const deleteCurrency = async (id: number) => {
  const result = await axiosInstance.delete(`currency/${id}`);
  return result.data;
};
